export const LANDING_PAGE_CMS_DATA = "/apim-admin";
export const GRAPHQL_PROXY = "api/graphql-proxy";
export const USER_BASE_URL = "https://apim-admin-cms-qa-dpekdafdd8gngkf7.australiasoutheast-01.azurewebsites.net/";